import { DashboardMetric, StatsData } from '../../types/bookingCreation';

/**
 * Which KPI tiles must say "could not be loaded" instead of showing a figure
 * (#2864 — A Failure Must Never Look Like an Absence).
 *
 * A metric has failed when the whole request failed, when the backend names it
 * in `failedMetrics`, or when its figure is simply not in the response — the
 * backend leaves a failed metric out rather than answering it with zeros, so a
 * missing figure is never read as "nothing happened in this period".
 */
export const failedDashboardMetrics = (
    stats: StatsData | undefined,
    requestFailed: boolean,
): Set<DashboardMetric> => {
    const all: DashboardMetric[] = ['bookings', 'revenues', 'utilization'];
    if (requestFailed || !stats) return new Set(all);
    const named = new Set<DashboardMetric>(Array.isArray(stats.failedMetrics) ? stats.failedMetrics : []);
    return new Set(all.filter((metric) => named.has(metric) || stats[metric] == null));
};
